export const typeDocCrubs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sportello',
    path: '/sportello',
  },
  {
    name: 'Tipo documento',
    path: '/sportello/tipo-doc',
  },
];
